import { Dropdown, Message, Typography } from "@arco-design/web-react";
import { IconCopy, IconRight } from "@arco-design/web-react/icon";
import userStore from "@/stores/user";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import RightsDetail from "@/pages/RightsDetail";
import { copyText } from "@/utils/tool";
import teamStore from "@/stores/team";
import "./index.less";

import vip_icon from "@/pages/HomeLogin/images/vip_icon.png";
import rights_icon from "@/pages/HomeLogin/images/rights_icon.png";
import num_icon from "@/pages/HomeLogin/images/num_icon.png";
import user_iocn from "@/pages/HomeLogin/images/user_icon.png";

const User: React.FC = observer(() => {
  // 参数
  const navigate = useNavigate();
  // 算力信息
  const {
    surplus = 0,
    expires_time,
    package_name = "",
  } = teamStore.packageInfo.packageList.find((item) => item.benefit_type === 24) || {};
  // 菜单项

  const menuItems = [
    { key: "user", title: "个人中心", link: "/user" },
    { key: "equity", title: "权益明细" },
    { key: "statics", title: "算力消耗明细", link: "/consume-details" },
  ];
  const [rightsVisible, setRightsVisible] = useState<boolean>(false); // 权益详情弹窗

  return (
    <>
      {userStore.userInfo?.id ? (
        <div className="user-box">
          <div className="user_content">
            <div className="user_content_statis">
              <img src={num_icon} alt="" />
              剩余星算力&nbsp;<span>{surplus}</span>
            </div>
            {/* 头像 */}
            <Dropdown
              droplist={
                <div className="user_popover_card">
                  <div className="popover_content_header">
                    <div
                      className="content_header_avatar"
                      style={{
                        background: userStore.userInfo?.avatar
                          ? `url(${userStore.userInfo?.avatar}) center/cover`
                          : userStore.userInfo?.avatar_color,
                      }}
                    >
                      {!userStore.userInfo?.avatar && userStore.userInfo?.nickname?.slice(-2)}
                    </div>
                    <div className="content_header_info">
                      <div className="info_name">{userStore.userInfo?.nickname}</div>
                      {userStore.userInfo?.phone_number && (
                        <div className="info_phone_number">
                          {userStore.userInfo?.phone_number}{" "}
                          <IconCopy
                            style={{ fontSize: 16, color: "#B5BAC0", cursor: "pointer" }}
                            onClick={() => {
                              copyText(userStore.userInfo?.phone_number);
                              Message.success("复制成功");
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="popover_content_card">
                    <img src={rights_icon} className="popover_content_card_icon" />
                    <div className="card_header">
                      <div className="card_header_title">
                        <img src={vip_icon} alt="" />
                        <Typography.Text ellipsis={{ rows: 1, showTooltip: true }} className="header_title_text">
                          {package_name}
                        </Typography.Text>
                      </div>
                      <div className="card_header_btn" onClick={() => Message.info("请联系专属客服")}>
                        续费/升级
                      </div>
                    </div>
                    <div className="card_valid">有效期至{expires_time}</div>
                    <div className="card_foot">
                      <div className="card_foot_content">
                        <img src={user_iocn} />
                        <div className="foot_content_text">
                          星算力<span>{surplus}</span>
                        </div>
                        <div className="foot_content_btn" onClick={() => Message.info("请联系专属客服")}>
                          充值
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="popover_content_menu">
                    {menuItems.map((item) => (
                      <div
                        key={item.key}
                        className="menu_item"
                        onClick={() => {
                          if (item.key === "equity") {
                            setRightsVisible(true);
                          } else {
                            if (item?.link) navigate(item.link);
                          }
                        }}
                      >
                        {item.title}
                        <IconRight style={{ color: "#999" }} />
                      </div>
                    ))}
                    <div
                      className="menu_login_out"
                      onClick={() => {
                        localStorage.removeItem("VideoResult");
                        localStorage.removeItem("uploadTasks");
                        localStorage.removeItem("isExpired_at_package");
                        localStorage.clear();
                        userStore.userInfo.id = undefined;
                        userStore.setIsLogin(true);
                        setTimeout(() => {
                          userStore.setIsLogin(false);
                        }, 500);
                        navigate("/");
                      }}
                    >
                      退出登录
                    </div>
                  </div>
                </div>
              }
              position="br"
              onVisibleChange={(visible) => {
                if (visible) {
                  teamStore.getPackageInfo();
                }
              }}
            >
              <div
                className="user_avatar"
                style={{
                  background: userStore.userInfo?.avatar
                    ? `url(${userStore.userInfo?.avatar}) center/cover`
                    : userStore.userInfo?.avatar_color,
                }}
              >
                {!userStore.userInfo?.avatar && userStore.userInfo?.nickname?.slice(-2)}
              </div>
            </Dropdown>
          </div>
        </div>
      ) : (
        <div className="user_login_btn" onClick={() => userStore.setIsLogin(false)}>
          登录
        </div>
      )}
      <RightsDetail visible={rightsVisible} onClose={() => setRightsVisible(false)} />
    </>
  );
});
export default User;
